import { Injectable } from '@angular/core';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { Store } from '@ngxs/store';
import { filter, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  AllocationViewDropAllocationAction,
  AllocationViewDropAllocationActionSetInitialState,
} from './allocation-view-drop-allocation-action.actions';
import { AllocationViewDropAllocationActionState } from './allocation-view-drop-allocation-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewDropAllocationActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewDropAllocationActionState.getLoaded);

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  execute(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewDropAllocationAction({
            identifier,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewDropAllocationActionSetInitialState());
  }
}
